import ManageClientsDashboard from './ManageClientsDashboard';

export default ManageClientsDashboard;
